import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(theme => ({
  homePage: {
    '& button': {
      // textIndent: '-9999px', # This makes some buttons not understandable for screen readers, so we will not use it for now
      padding: '0.5rem',

      '> span > span': {
        margin: '0',
      },
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
  header: {
    width: `calc(100% - var(--button-width, 0px) - 1rem)`,
  },
  homePageGrid: {
    marginTop: '-2.5rem',
    '& .react-grid-item': {
      padding: '0.25rem',
    },
  },
  homePageGridSaveMode: {
    marginTop: '0',
  },
  hidden: {
    display: 'none !important',
  },
}));
